module.exports = __webpack_public_path__ + "static/media/expand.2358f60d.svg";